/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import SqlImportModel from 'cio/models/sql-import';
import AnalyticsService from 'cio/services/analytics';
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

interface SqlImportsImportRowsCancelImportModalArgs {
  cancelImportTask: Task<unknown, any[]>;
  onClose: () => void;
  sqlImportModel: SqlImportModel;
}

export default class SqlImportsImportRowsCancelImportModal extends Component<SqlImportsImportRowsCancelImportModalArgs> {
  @service analytics!: AnalyticsService;

  @action
  async cancelImport() {
    await this.args.cancelImportTask.perform();
    this.analytics.track('sql_imports', 'cancel_import_started', { model: this.args.sqlImportModel });
    this.args.onClose();
  }

  @action
  onClose() {
    this.analytics.track('sql_imports', 'cancel_import_canceled', { model: this.args.sqlImportModel });
    this.args.onClose();
  }
}
